import { ForgeProjectArtifact, ForgeProjectArtifactContentData, Id, } from "@supernova-studio/model";
import { DTOThreadMessageCreateInput } from "../threads";
import { DTOForgeSectionItemMoveInput } from "./project-section";
import { z } from "zod";
const omitProps = {
    projectId: true,
    createdByUserId: true,
    createdAt: true,
    updatedAt: true,
    sortOrder: true,
};
export const DTOForgeProjectArtifact = ForgeProjectArtifact;
export const DTOForgeProjectArtifactUpdateInput = z.object({
    id: z.string(),
    title: z.string().optional(),
    isArchived: z.boolean().optional(),
});
export const DTOForgeProjectArtifactCreateInput = z.object({
    id: z.string(),
    title: z.string(),
    sectionId: z.string().optional(),
    afterArtifactId: z.string().optional().nullable(),
    initialMessage: DTOThreadMessageCreateInput.optional(),
});
export const DTOForgeProjectArtifactDeleteInput = z.object({
    id: Id,
});
export const DTOForgeProjectArtifactMoveInput = DTOForgeSectionItemMoveInput;
export const DTOForgeDocumentGetByIdParam = z.object({
    id: Id,
});
export const DTOForgeProjectArtifactGetResponse = z.object({
    artifact: DTOForgeProjectArtifact,
});
export const DTOForgeDocumentGetResponse = z.object({
    document: DTOForgeProjectArtifact,
});
export const DTOForgeProjectArtifactCreateResponse = z.object({
    artifact: DTOForgeProjectArtifact,
});
export const DTOForgeProjectArtifactUpdateResponse = z.object({
    artifact: DTOForgeProjectArtifact,
});
export const DTOForgeProjectArtifactDeleteResponse = z.object({
    ok: z.literal(true),
});
export const DTOForgeProjectArtifactMoveResponse = z.object({
    artifact: DTOForgeProjectArtifact,
});
export const DTOForgeProjectArtifactsListResponse = z.object({
    artifacts: z.array(DTOForgeProjectArtifact),
});
export const DTOForgeProjectArtifactContentResponse = z.object({
    artifactId: z.string(),
    content: ForgeProjectArtifactContentData,
});
